// extracted by mini-css-extract-plugin
module.exports = {"varSpUp1":"1.25rem","content":"content--a54bd","removeContainer":"removeContainer--9c686"};